import { EuiText,
    EuiFlexGroup,
    EuiForm, EuiFormRow, EuiFieldText, EuiSpacer,
    EuiButton, EuiHorizontalRule
 } from "@elastic/eui";

import { useAppSelector, useAppDispatch } from "../app/hooks";
import Header from "../components/Header";
import { useState } from "react";
import { firebaseDB, usersRef, firebaseAuth } from '../utils/FirebaseConfig';
import { doc, updateDoc, query, where, getDocs } from 'firebase/firestore';
import { updateProfile } from "firebase/auth";
import { setUser } from "../app/slices/AuthSlice";

import { sendPasswordResetEmail } from 'firebase/auth';


export default function UserProfile(){

    const dispatch = useAppDispatch(); 
    
    const userName = useAppSelector((state) => state.auth.userInfo?.name);

    const [newUserName, setNewUserName] = useState(userName);

    const [error, setError] = useState<string | null>(null);

    const upadateUser = async () => {
    try {
        console.log("cc");
        if (!userName) throw new Error("Utilisateur non connecté");
    
        const user = firebaseAuth.currentUser;
        if (user) {
            //const userDocRef = doc(firebaseDB, "users", userUid);
            
            // Mettre à jour le nom dans Firebase Auth
            await updateProfile(user, { displayName: newUserName });

            // Trouver le document utilisateur dans Firestore
            const q = query(usersRef, where("uid", "==", user.uid));
            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                const userDoc = snapshot.docs[0];
                const userDocRef = doc(firebaseDB, "users", userDoc.id);

                // 3. Mettre à jour le nom dans Firestore
                await updateDoc(userDocRef, { name: newUserName });


            
            // 3. Mettre à jour le state global (Redux)
            dispatch(setUser({
                uid: user.uid,
                email: user.email!,
                name: newUserName!,
            }));
            
        }
      
        }
    } catch (error) {
        console.error("Erreur lors de la mise à jour :", error);
    } 
    }

    const sendResetEmail = async (e: React.FormEvent) => {

        console.log("Bonjour !");
        e.preventDefault();
        const user = firebaseAuth.currentUser;
        if (user) {
            try {
                
                await sendPasswordResetEmail(firebaseAuth, user.email!);
                setError(null);
                alert('Password reset email sent! Please check your inbox.');
                
              } catch (err) {
                console.error('Error sending password reset email:', err);
                setError('Failed to send password reset email.');
              }
        }
    
        
      };
   

    return (
        <div>
         
        <div
            style={{
                display: "flex",
                height: "100vh",
                flexDirection: "column",
            }}>
            <Header />
            <EuiSpacer />
            <EuiText textAlign="center">
                <h3> Modifier Profil</h3>
            </EuiText>
            <EuiFlexGroup justifyContent="center" alignItems="center">
                    <EuiForm >
                        <EuiFormRow label="Modifier nom" >
                            <EuiFieldText name="name"
                            value={newUserName} 
                            onChange={(e) => setNewUserName(e.target.value)}
                            />
                        </EuiFormRow>
                        <EuiSpacer />
                        <EuiButton type="submit" 
                            onClick={() => upadateUser()}
                            fill>
                            Sauvegarder
                        </EuiButton>
                        <EuiSpacer />

                        
                    </EuiForm>
                    
                </EuiFlexGroup>
                <EuiHorizontalRule size="quarter" />
            <EuiFlexGroup justifyContent="center" >
                
                <form onSubmit={sendResetEmail}>
                        <EuiButton  color="danger" type="submit" >
                            Changer le mot de passe
                        </EuiButton>
                        {error && <EuiText color="danger">{error}</EuiText>}
                </form>
            </EuiFlexGroup>

        </div>       
       
        </div>              
        
    );
}